module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "c5",
    attrs: {
      "id": "calibre_pb_3"
    }
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c7"
  }, [_vm._v("To Amelia,")]), _vm._v(" "), _c('p', {
    staticClass: "c7"
  }, [_vm._v("You’re not even born yet and")]), _vm._v(" "), _c('p', {
    staticClass: "c7"
  }, [_vm._v("you already have a book dedicated to you.")]), _vm._v(" "), _c('p', {
    staticClass: "c7"
  }, [_vm._v("I love you.")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_c('br', {
    staticClass: "calibre2"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54d304e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_0a9fca13b620a2de592dddca89bae7c7_34PU7E.ch.fixed.fc.tidied.stylehacked.xfixed_split_004.vue
// module id = 72
// module chunks = 0